import pSBC from './vendor/pSBC';

export default function(bgColor) {
  bgColor = pSBC.pSBCr(bgColor);
  var yiq = (bgColor.r * 299 + bgColor.g * 587 + bgColor.b * 114) / 1000;
  return yiq >= 128 ? '#000000' : '#FFFFFF';
}
